'use strict'

const Noc = {
    el: Element,
    query: function (element){
        this.el = document.querySelector(element)
        return this
    },
    masterLoading: function(param, html = ``){
        let classData = this.el.getAttribute('class')

        if(html){
            this.el.querySelector('.noc-master-loading-text').innerHTML = html
        } else {
            this.el.querySelector('.noc-master-loading-text').innerHTML = `<p class="mb-[0.5rem] font-bold italic">Memuat Data</p><div class="--loading__bar relative h-[5px] w-[12rem] bg-slate-500 rounded-[2em] overflow-hidden after:absolute after:top-0 after:left-0 after:w-1/2 after:h-full after:rounded-[1em]"></div>`
        }

        if(param == 'show') {

            if(classData){
                if(!this.el.classList.contains('flex')){
                    this.el.classList.add('flex')
                }
                this.el.classList.remove('hidden')
            }

        } else if (param == 'hide') {

            if(classData){
                if(!this.el.classList.contains('hidden')){
                    this.el.classList.add('hidden')
                }
            }

        }
    },
    listen: function(type, callback) {
        if ( type.includes('ui.modal.') || type.includes('ui.sidebar.') ) {
            this.el.addEventListener(`noc.${String(type)}`, (e) => {
                callback(e)
            })
        } else {
            this.el.addEventListener(String(type), (e) => {
                callback(e)
            })
        }
    },
    modal: function(param, options) {

        const ops = {
            classFirst: this.el,
            classSecond: this.el.querySelector('div')
        }

        if(options && options.hasOwnProperty('oneElement')){
            if(options.oneElement){
                ops.classSecond = ops.classFirst
            }
        }

        
        // const show = () => {
            
        //     ops.classFirst.dispatchEvent(new CustomEvent('unmodal.show', {
        //         detail: {}
        //     }))

        //     setTimeout(() => {
        //         ops.classFirst.dispatchEvent(new CustomEvent('unmodal.shown', {
        //             detail: {}
        //         }))
        //     }, 400);

        //     ops.classFirst.classList.remove('hidden')
        //     ops.classSecond.classList.add('transition-opacity', 'ease-in-out', 'duration-200')
        //     setTimeout(() => {
        //         ops.classSecond.classList.add('opacity-100')
                
        //         setTimeout(() => {
        //             ops.classSecond.classList.remove('opacity-0')
        //         }, 300);
        //     }, 100);
        // }
        const show = () => {
            this.el.dispatchEvent(new CustomEvent('noc.ui.modal.show', {
                detail: {}
            }))

            setTimeout(() => {
                this.el.dispatchEvent(new CustomEvent('noc.ui.modal.shown', {
                    detail: {}
                }))
            }, 400);

            this.el.classList.remove('hidden');
            setTimeout(() => {
                this.el.classList.add('transition-opacity', 'ease-in-out', 'duration-150')
                setTimeout(() => {
                    this.el.classList.add('opacity-100');
                    setTimeout(() => {
                        this.el.classList.remove('opacity-0');
                    }, 200);
                }, 100);
            }, 100);
        }

        const hide = () => {

            this.el.dispatchEvent(new CustomEvent('noc.ui.modal.hide', {
                detail: {}
            }))

            setTimeout(() => {
                this.el.dispatchEvent(new CustomEvent('noc.ui.modal.hidden', {
                    detail: {}
                }))
            }, 400);

        
            this.el.classList.remove('opacity-100');
            setTimeout(() => {
                this.el.classList.add('opacity-0')
                setTimeout(() => {
                    this.el.classList.add('hidden');
                    setTimeout(() => {
                        this.el.classList.remove('transition-opacity', 'ease-in-out', 'duration-150');
                    }, 200);
                }, 100);
            }, 100);
        }

        if(param == 'show') {
            show()
            return
        } else if (param == 'hide') {
            hide()
            return
        } else if (param == 'toggle') {
            if(ops.classFirst.classList.contains('hidden')){
                show()
                return
            } else {
                hide()
                return
            }
        }
    },
    sidebar: function(param) {

        switch (param) {
            case 'show':
                this.el.dispatchEvent(new CustomEvent('noc.ui.sidebar.show', {
                    detail: {}
                }))

                if ( this.el.classList.contains('left-0') ) {
                    this.el.classList.replace('left-0', 'left-2')
                    this.el.classList.replace('-translate-x-full', '-translate-x-0')
                } else if ( this.el.classList.contains('right-0') ) {
                    this.el.classList.replace('right-0', 'right-1')
                    this.el.classList.replace('translate-x-full', '-translate-x-1')
                }

                setTimeout(() => {
                    this.el.dispatchEvent(new CustomEvent('noc.ui.sidebar.shown', {
                        detail: {}
                    }))
                }, 160);
                break;
            case 'hide':
                this.el.dispatchEvent(new CustomEvent('noc.ui.sidebar.hide', {
                    detail: {}
                }))

                if ( this.el.classList.contains('left-2') ) {
                    this.el.classList.replace('left-2', 'left-0')
                    this.el.classList.replace('-translate-x-0', '-translate-x-full')
                } else if ( this.el.classList.contains('right-1') ) {
                    this.el.classList.replace('right-1', 'right-0')
                    this.el.classList.replace('-translate-x-1', 'translate-x-full')
                }

                setTimeout(() => {
                    this.el.dispatchEvent(new CustomEvent('noc.ui.sidebar.hidden', {
                        detail: {}
                    }))
                }, 160);
                break;
            default:
                break;
        }
    },
    reset: function() {
        this.el.reset()
    }
}

// export default (el) => Noc.query(el)

export default function useNoc(el) {
    return Noc.query(el);
}